export function devWarn(message: string) {
  if (
    process.env.NODE_ENV === 'development' &&
    process.env.VKIT_SHOW_DEVELOPMENT_WARNINGS !== 'false'
  ) {
    console.warn(message)
  }
}